<template>
    <div id="ComponentModalCriarProcessoPorRegistro">
        <div class="modal fade modern-modal" id="ModalCriarProcessoPorRegistro" tabindex="-1" data-bs-focus="false">
            <div class="modal-dialog modal-dialog-centered modal-modern modal-grande">
                <div class="modal-content modal-modern-content border-0">

                    <button type="button"
                            class="btn btn-md btn-icon btn-pill btn-white shadow position-absolute top-0 end-0 mt-n3 me-n3 btn-close-modern"
                            :disabled="loading"
                            data-bs-dismiss="modal">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-lg" viewBox="0 0 16 16">
                            <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8z" />
                        </svg>
                    </button>

                    <div class="modal-modern-header">
                        <div class="header-icon">
                            <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none">
                                <path d="M12 4V20M4 12H20" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                        </div>
                        <div class="header-text">
                            <h2>Criar Processo a partir de Registros</h2>
                            <p>Defina os dados do processo e selecione, por item, de quais registros/setores você vai utilizar.</p>
                        </div>
                        <div class="header-status">
                            <div class="tabs-row">
                                <button class="tab-btn"
                                        :class="{ active: activeTab === 'processo' }"
                                        @click="activeTab='processo'">
                                    Processo
                                </button>

                                <button class="tab-btn"
                                        :class="{ active: activeTab === 'itens', blocked: activeTab !== 'itens' && !processoOk }"
                                        @click="irParaItens">
                                    Itens
                                </button>

                                <button class="tab-btn"
                                        :class="{ active: activeTab === 'quantidades', blocked: activeTab !== 'quantidades' && !processoOk }"
                                        @click="irParaQuantidades">
                                    Quantidades
                                </button>
                            </div>
                        </div>
                    </div>

                    <div class="modal-modern-body">
                        <!-- ===================== ABA PROCESSO ===================== -->
                        <div v-show="activeTab==='processo'">
                            <div class="form-grid form-grid-3">
                                <div class="form-group">
                                    <label class="form-label">Número do Processo</label>
                                    <input type="text" class="form-control"
                                           v-model="cdProcessoNumero"
                                           :class="{ 'border-danger': camposInvalidos.cdProcessoNumero }"
                                           maxlength="50" />
                                </div>

                                <div class="form-group">
                                    <label class="form-label">Legislação</label>
                                    <select class="form-control"
                                            v-model="legislacaoSelecionadaId"
                                            :class="{ 'border-danger': camposInvalidos.legislacaoSelecionadaId }">
                                        <option disabled value="">Selecione uma Legislação</option>
                                        <option v-for="leg in (legislacoes || [])"
                                                :key="leg.idLegislacao"
                                                :value="String(leg.idLegislacao)">
                                            {{ leg.dsNome }}
                                        </option>
                                    </select>
                                </div>

                                <div class="form-group">
                                    <label class="form-label">Tipo de Processo</label>
                                    <select class="form-control"
                                            v-model="ProcessoSelecionadoId"
                                            :class="{ 'border-danger': camposInvalidos.ProcessoSelecionadoId }">
                                        <option disabled value="">Selecione um Tipo</option>
                                        <option v-for="proc in (tiposProcessos || [])"
                                                :key="proc.idTipoProcesso"
                                                :value="String(proc.idTipoProcesso)">
                                            {{ proc.nmTipoProcesso }}
                                        </option>
                                    </select>
                                </div>
                            </div>

                            <SelectWorkflowProcesso v-model="idProcessoWorkflowSelecionado"
                                                    select-id="workflowProcessoPorRegistro"
                                                    :id-legislacao="legislacaoSelecionadaId"
                                                    :id-tipo-processo="ProcessoSelecionadoId"
                                                    :preferred-id="workflowPreferencialId"
                                                    @state="atualizarEstadoWorkflow" />

                            <div class="form-grid form-grid-2">
                                <div class="form-group">
                                    <label class="form-label">Nome do Processo</label>
                                    <input type="text" class="form-control"
                                           v-model="dsNomeProcesso"
                                           :class="{ 'border-danger': camposInvalidos.dsNomeProcesso }"
                                           maxlength="200" />
                                </div>

                                <div class="form-group">
                                    <label class="form-label">Lote Único</label>
                                    <select class="form-control"
                                            v-model="flLoteUnico"
                                            :class="{ 'border-danger': camposInvalidos.flLoteUnico }">
                                        <option disabled value="">Selecione:</option>
                                        <option :value="true">Sim</option>
                                        <option :value="false">Não</option>
                                    </select>
                                </div>
                            </div>

                            <div class="form-group">
                                <label class="form-label">Descrição do Processo</label>
                                <textarea class="form-control form-textarea"
                                          v-model="dsProcesso"
                                          maxlength="500"
                                          rows="3"></textarea>
                                <small class="text-muted">Máximo de 500 caracteres.</small>
                            </div>

                            <div v-if="hasMatchingWorkflow" class="form-grid form-grid-2">
                                <div>
                                    <label class="form-label">Data de início</label>
                                    <input type="date" class="form-control"
                                           v-model="dtInicio"
                                           :class="{ 'border-danger': camposInvalidos.dtInicio }" />

                                    <div class="form-grid form-group-inline mt-2">

                                        <div class="info-chip w-100">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                                                <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                                                <path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 .876-.252 1.02-.598l.088-.416c.066-.3.104-.378.288-.41l.451-.083.082-.38-1.428-.287.545-2.545z" />
                                                <circle cx="8" cy="4.5" r="1" />
                                            </svg>
                                            Os prazos definidos no fluxo serão contabilizados a partir desta data.
                                        </div>
                                    </div>
                                </div>
                                <div>
                                    <label class="form-label">Data estimada de finalização</label>
                                    <input type="date" class="form-control"
                                           v-model="dtFinalizacaoEstimada" />
                                </div>
                            </div>
                        </div>

                        <!-- ===================== ABA ITENS ===================== -->
                        <div v-show="activeTab==='itens'">
                            <div class="custom-table-header">
                                <div class="header-toolbar">
                                    <div class="left-tools">
                                        <div class="filter-select d-none">
                                            <!--<label class="filter-label">Registro</label>-->
                                            <select class="filter-select-input" v-model.number="filtroRegistroId" :disabled="loading">
                                                <option :value="null">Todos</option>
                                                <option v-for="r in registros"
                                                        :key="r.idRegistroNecessidade"
                                                        :value="r.idRegistroNecessidade">
                                                    {{ r.nmRegistroNecessidade }}
                                                </option>
                                            </select>
                                        </div>

                                        <div class="search-box">
                                            <svg class="search-icon" xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" viewBox="0 0 16 16">
                                                <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z" />
                                            </svg>
                                            <input v-model="itemFilter"
                                                   type="text"
                                                   class="search-input"
                                                   placeholder="Buscar por Nome ou Referência" />
                                        </div>

                                        <button type="button"
                                                class="toolbar-btn toolbar-btn-refresh"
                                                :disabled="loading"
                                                @click="recarregarItens">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                                                <path fill-rule="evenodd" d="M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2v1z" />
                                                <path d="M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466z" />
                                            </svg>
                                            Atualizar
                                        </button>
                                    </div>

                                    <div class="right-tools">
                                        <div class="totals">
                                            <span class="total-chip">Itens: <b>{{ itensFiltrados.length }}</b></span>
                                            <span class="total-chip">Selecionados: <b>{{ qtdItensSelecionados }}</b></span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- Lotes "reais": seleciona lote atual -->
                            <div class="custom-table-header" v-if="flLoteUnico === false">
                                <div class="header-toolbar header-toolbar-lotes">
                                    <div class="right-tools right-tools-lotes">
                                        <div class="totals">
                                            <span class="total-chip">Lotes:</span>

                                            <button v-for="l in lotes"
                                                    :key="l"
                                                    type="button"
                                                    class="total-chip"
                                                    :class="{ 'chip-active': activeLote === l }"
                                                    @click="setActiveLote(l)">
                                                Lote {{ l }}
                                                <b v-if="countDetailsInLote(l)">({{ countDetailsInLote(l) }})</b>
                                            </button>

                                            <button class="modern-btn modern-btn-secondary" type="button" @click="addLote">+ Lote</button>
                                            <button class="modern-btn modern-btn-danger" type="button" @click="removeLote">- Lote</button>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="table-wrapper modern-table" style=" overflow: auto; max-height: 55vh;">
                                <table class="custom-table">
                                    <thead>
                                        <tr>
                                            <th style="width:1%"></th>
                                            <th class="text-center" style="white-space:nowrap;width:1%;">Item</th>
                                            <th>Nome</th>
                                            <th>Tipo do Item</th>
                                            <th class="text-center" style="white-space:nowrap;width:1%;">Qtd Total Requisitada</th>
                                            <!--<th class="text-center" style="white-space:nowrap;width:1%;">Ações</th>-->
                                        </tr>
                                    </thead>

                                    <tbody>
                                        <template v-for="(row, idx) in itensFiltrados">
                                            <tr :key="'row-' + (row.idItem || idx)">
                                                <!-- checkbox do item: SOMENTE indicador (não clicável) -->
                                                <td class="text-center">
                                                    <input type="checkbox"
                                                           
                                                           :checked="isItemOpen(row.idItem)"
                                                           @change="toggleItem(row)"
                                                           title="A seleção do item é definida pelos detalhes marcados." />
                                                </td>

                                                <td class="text-center">
                                                    <span class="id-badge">{{ row.cdItem }}</span>
                                                </td>

                                                <td>
                                                    <div class="item-name">{{ row.nmItem }}</div>
                                                    <div class="item-details">
                                                        {{ row.cdReferencia || '-' }}
                                                        <span v-if="row.tpItem"> • {{ row.tpItem }}</span>
                                                    </div>
                                                </td>

                                                 <td>
                                                     <template v-if="row.flPadrao" >
                                                         <span>{{row.tpItem == 'M'?'CatMat':'CatSer'}}</span>
                                                     </template>
                                                     <span v-else>
                                                         Interno - {{row.tpItem == 'M'?'Material':'Serviço'}}
                                                     </span>
                                                 </td>

                                                <td class="text-center">
                                                    <span class="number-badge">{{ formatarQtd(row.qtdTotal) }}</span>
                                                </td>

                                                <!--<td class="text-center">
                                                    <button type="button"
                                                            class="action-btn action-btn-view"
                                                            :disabled="loading"
                                                            @click="toggleDetails(row)">
                                                        {{ isDetailsOpen(row.idItem) ? 'Fechar' : 'Detalhes' }}
                                                    </button>
                                                </td>-->
                                            </tr>

                                            
                                        </template>

                                        <tr v-if="!loading && itensFiltrados.length === 0">
                                            <td :colspan="5" class="empty-state">
                                                <div class="empty-content">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" fill="currentColor" viewBox="0 0 16 16" class="empty-icon">
                                                        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                                                        <path d="M8.93 6.588l-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533z" />
                                                        <circle cx="8" cy="4.5" r="1" />
                                                    </svg>
                                                    <h3 class="empty-title">Nada encontrado</h3>
                                                    <p class="empty-description">Tente ajustar o filtro.</p>
                                                </div>
                                            </td>
                                        </tr>

                                        <tr v-if="loading">
                                            <td :colspan="5" class="empty-state">
                                                <div class="empty-content">
                                                    <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                                    <h3 class="empty-title">Carregando...</h3>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>

                        <!-- ===================== ABA QUANTIDADES ===================== -->
                        <div v-show="activeTab==='quantidades'">
                            <div class="custom-table-header">
                                <div class="header-toolbar">
                                    <div class="left-tools">
                                        <div class="search-box">
                                            <svg class="search-icon" xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" viewBox="0 0 16 16">
                                                <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z" />
                                            </svg>
                                            <input v-model="itemFilter"
                                                   type="text"
                                                   class="search-input"
                                                   placeholder="Buscar por Nome ou Referência" />
                                        </div>

                                        <button type="button"
                                                class="toolbar-btn toolbar-btn-refresh"
                                                :disabled="loading"
                                                @click="recarregarItens">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                                                <path fill-rule="evenodd" d="M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2v1z" />
                                                <path d="M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466z" />
                                            </svg>
                                            Atualizar
                                        </button>
                                    </div>

                                    <div class="right-tools">
                                        <div class="totals">
                                            <span class="total-chip">Itens: <b>{{ itensFiltrados.length }}</b></span>
                                            <span class="total-chip">Selecionados: <b>{{ qtdItensSelecionados }}</b></span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- Lotes "reais": seleciona lote atual -->
                            <div class="custom-table-header" v-if="flLoteUnico === false">
                                <div class="header-toolbar header-toolbar-lotes">
                                    <div class="right-tools right-tools-lotes">
                                        <div class="totals">
                                            <span class="total-chip">Lote atual:</span>

                                            <button v-for="l in lotes"
                                                    :key="l"
                                                    type="button"
                                                    class="total-chip"
                                                    :class="{ 'chip-active': activeLote === l }"
                                                    @click="setActiveLote(l)">
                                                Lote {{ l }}
                                                <b v-if="countDetailsInLote(l)">({{ countDetailsInLote(l) }})</b>
                                            </button>

                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="table-wrapper modern-table" style=" overflow: auto; max-height: 55vh;">
                                <table class="custom-table custom-table-quantidades">
                                    <thead>
                                        <tr>
                                            <th class="text-center" style="white-space:nowrap;width:1%;">Item</th>
                                            <th>Nome</th>
                                            <th>Tipo do Item</th>
                                            <th class="text-center" style="white-space:nowrap;width:1%;">Qtd Total Requisitada</th>
                                            <th class="text-center" style="white-space:nowrap;width:1%;">Qtd Total Utilizada</th>
                                            <th class="text-center" style="width:10%; white-space:nowrap;">Unid. Medida</th>
                                            <th class="text-center" style="width:10%; white-space:nowrap;">Valor Unitário</th>
                                            <th class="text-center" style="width:10%; white-space:nowrap;">Valor Total</th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        <template v-for="(row, idx) in itensSelecionadosFiltrados">
                                            <tr :key="'row-' + (row.idItem || idx)">
                                                
                                                <td class="text-center">
                                                    <span class="id-badge">{{ row.cdItem }}</span>
                                                </td>

                                                <td>
                                                    <div class="item-name">{{ row.nmItem }}</div>
                                                    <div class="item-details">
                                                        {{ row.cdReferencia || '-' }}

                                                    </div>
                                                </td>
                                                <td>
                                                    <template v-if="row.flPadrao">
                                                        <span>{{row.tpItem == 'M'?'CatMat':'CatSer'}}</span>
                                                    </template>
                                                    <span v-else>
                                                        Interno - {{row.tpItem == 'M'?'Material':'Serviço'}}
                                                    </span>
                                                </td>

                                                <td class="text-center">
                                                    <span class="number-badge">{{ formatarQtd(row.qtdTotal) }}</span>
                                                </td>

                                                <td class="text-center">
                                                    <span class="number-badge">{{ formatarQtd(getTotalUtilizado(row.idItem)) }}</span>
                                                </td>

                                                <!-- Unidade de Medida -->
                                                <td class="text-center">
                                                    <select class="form-control form-control-sm"
                                                            :class="{ 'border-danger': camposInvalidosQuantidades.unidadeMedida }"
                                                            :value="getDetailUnidade(row.idItem)"
                                                            @change="onChangeDetailUnidade(row.idItem, $event.target.value)">
                                                        <option disabled value="">Selecione</option>
                                                        <option v-for="um in (unidadesMedida || [])"
                                                                :key="um.idUnidadeMedida"
                                                                :value="um.idUnidadeMedida">
                                                            {{ formatarUnidade(um) }}
                                                        </option>
                                                    </select>
                                                </td>

                                                <!-- Valor Unitário -->
                                                <td class="text-center">
                                                    <div class="input-group input-group-sm" style="min-width:140px;">
                                                        <span class="input-group-text">R$</span>
                                                        <input type="text"
                                                               class="form-control"
                                                               :class="{ 'border-danger': camposInvalidosQuantidades.valorUnitario }"
                                                               :value="getDetailVlUnitFmt(row.idItem)"
                                                               @input="onInputDetailVlUnit(row.idItem, $event)" />
                                                    </div>
                                                </td>

                                                <!-- Valor Total -->
                                                <td class="text-center">
                                                    <span class="number-badge">
                                                        R$ {{ formatarMoeda(getDetailTotal(row.idItem)) }}
                                                    </span>
                                                </td>

                                            </tr>

                                            <!-- Detalhes expandido -->
                                            <tr  :key="'details-' + (row.idItem || idx)">
                                                <td :colspan="9">
                                                    <div class="section-card details-card">
                                                        <div class="dependency-toolbar d-none">
                                                            <div class="toolbar-text">
                                                                Defina as quantidades por <strong>registros/setores</strong> serão usados neste item.
                                                            </div>

                                                            <div class="toolbar-actions">
                                                                <button type="button"
                                                                        class="modern-btn modern-btn-secondary"
                                                                        :disabled="getDetailsState(row.idItem).loading"
                                                                        @click="utilizarTotalRequisitado(row.idItem)">
                                                                    Utilizar Total Requisitado
                                                                </button>
                                                            </div>
                                                        </div>

                                                        <div v-if="getDetailsState(row.idItem).loading" class="empty-state">
                                                            <div class="empty-content">
                                                                <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                                                <h3 class="empty-title">Carregando detalhes...</h3>
                                                            </div>
                                                        </div>

                                                        <div v-else class="table-wrapper modern-table">
                                                            <table class="custom-table custom-table-detalhes">
                                                                <thead>
                                                                    <tr>
                                                                        <th style="width:1%"></th>
                                                                        <th>Registro</th>
                                                                        <th style="width:10%">Setor</th>
                                                                        <th class="text-center" style="width:10%">Valor Unitário</th>
                                                                        <th class="text-center" style="width:10%">Qtd Requisitada</th>
                                                                        <th class="text-center" style="width:10%"></th>
                                                                        <th class="text-center" style="width:10%">Qtd Utilizada</th>
                                                                    </tr>
                                                                </thead>

                                                                <tbody>
                                                                    <tr v-for="d in getDetailsState(row.idItem).rows"
                                                                        :key="d.idRegistroNecessidadeItem">
                                                                        <td class="text-center">
                                                                            <input type="checkbox"
                                                                                   :checked="isItemOpenDetail(row.idItem,d.idRegistroNecessidadeItem)"
                                                                                   @change="toggleItemDetail(row.idItem,d.idRegistroNecessidadeItem)"
                                                                                   title="A seleção do item é definida pelos detalhes marcados." />
                                                                        </td>
                                                                        <td>
                                                                            <b>{{ d.nmRegistroNecessidade || ('Registro ' + d.idRegistroNecessidade) }}</b>
                                                                            <div class="text-muted" v-if="d.dsRegistroNecessidade">
                                                                                {{ d.dsRegistroNecessidade }}
                                                                            </div>
                                                                        </td>

                                                                        <td>
                                                                            <b>{{ d.nmSetorItem || d.nmSetor || '—' }}</b>
                                                                        </td>

                                                                        <td class="text-center">
                                                                            <template v-if="d.vlUnitarioItem">
                                                                                <b>R$ {{formatarMoeda(d.vlUnitarioItem)}}</b>
                                                                                <button class="btn btn-link px-2" @click="replicaVlUit(row.idItem,d.vlUnitarioItem)"><i class="fas fa-external-link-alt"></i></button>
                                                                            </template>                                                                            
                                                                            <b v-else>-</b>
                                                                        </td>

                                                                        <td class="text-center">
                                                                            <span class="number-badge">{{ formatarQtd(d.qtdItem) }}</span>
                                                                        </td>

                                                                        <td class="text-center">
                                                                            <button type="button"
                                                                                    class="modern-btn modern-btn-secondary"
                                                                                    :disabled="getDetailsState(row.idItem).loading"
                                                                                    @click="utilizarTotalRequisitado(row.idItem, d)"
                                                                                    title="Utilizar Total Requisitado">
                                                                                <i class="fas fa-arrow-right"></i>
                                                                            </button>
                                                                        </td>

                                                                        <td class="text-center">
                                                                            <input type="number"
                                                                                   class="form-control" :class="{ 'border-danger': camposInvalidosQuantidades.qtdForm }"
                                                                                   :disabled="!isItemOpenDetail(row.idItem,d.idRegistroNecessidadeItem)"
                                                                                   :value="getDetailQtdForm(row.idItem,d.idRegistroNecessidadeItem)"
                                                                                   @input="onInputDetailQtdForm(row.idItem,d.idRegistroNecessidadeItem, $event)" />
                                                                        </td>


                                                                    </tr>

                                                                    <tr v-if="getDetailsState(row.idItem).rows.length === 0">
                                                                        <td :colspan="flLoteUnico === false ? 8 : 7" class="empty-state">
                                                                            <div class="empty-content">
                                                                                <h3 class="empty-title">Nenhum detalhe encontrado</h3>
                                                                            </div>
                                                                        </td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>

                                                        </div>
                                                    </div>
                                                </td>
                                            </tr>
                                        </template>

                                        <tr v-if="!loading && itensFiltrados.length === 0">
                                            <td :colspan="9" class="empty-state">
                                                <div class="empty-content">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" fill="currentColor" viewBox="0 0 16 16" class="empty-icon">
                                                        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                                                        <path d="M8.93 6.588l-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533z" />
                                                        <circle cx="8" cy="4.5" r="1" />
                                                    </svg>
                                                    <h3 class="empty-title">Nada encontrado</h3>
                                                    <p class="empty-description">Tente ajustar o filtro.</p>
                                                </div>
                                            </td>
                                        </tr>

                                        <tr v-if="loading">
                                            <td :colspan="9" class="empty-state">
                                                <div class="empty-content">
                                                    <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                                    <h3 class="empty-title">Carregando...</h3>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>

                    <div class="modal-modern-footer">
                        <!-- ETAPA 1: Processo -->
                        <template v-if="activeTab === 'processo'">
                            <div class="d-flex gap-2">
                                <button type="button"
                                        class="modern-btn modern-btn-secondary flex-fill"
                                        :disabled="loading"
                                        data-bs-dismiss="modal">
                                    Cancelar
                                </button>

                                <button type="button"
                                        class="modern-btn modern-btn-primary flex-fill"
                                        :disabled="loading"
                                        @click="irParaItens">
                                    Próximo
                                </button>
                            </div>
                        </template>

                        <!-- ETAPA 2: Itens -->
                        <template v-else-if="activeTab === 'itens'">
                            <div class="d-flex gap-2">
                                <button type="button"
                                        class="modern-btn modern-btn-light flex-fill"
                                        :disabled="loading"
                                        @click="activeTab = 'processo'">
                                    Voltar
                                </button>

                                <button type="button"
                                        class="modern-btn modern-btn-primary flex-fill"
                                        :disabled="loading"
                                        @click="irParaQuantidades">
                                    Próximo
                                </button>
                            </div>
                        </template>

                        <!-- ETAPA 3: Quantidades -->
                        <template v-else>
                            <div class="d-flex gap-2">
                                <button type="button"
                                        class="modern-btn modern-btn-light flex-fill"
                                        :disabled="loading"
                                        @click="activeTab = 'itens'">
                                    Voltar
                                </button>

                                <button type="button"
                                        class="btn btn-primary btn-modern-primary flex-fill"
                                        :disabled="loading"
                                        @click="salvar">
                                    Salvar Processo
                                </button>
                            </div>
                        </template>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { urlApi, avisoErro, avisoToast } from '@/config/global'
    import axios from 'axios'
    import SelectWorkflowProcesso from '@/components/ProcessoInteligente/SelectWorkflowProcesso.vue'

    export default {
        name: 'ModalCriarProcessoPorRegistro',
        components: { SelectWorkflowProcesso },

        props: {
            legislacoes: { type: Array, default: () => [] },
            tiposProcessos: { type: Array, default: () => [] },
            idProcesso: { type: Number, default: () => 0 },
        },

        data() {
            return {
                bsModal: null,
                activeTab: 'processo',
                loading: false,
                registros: [],
                filtroRegistroId: null,

                // Form do processo
                legislacaoSelecionadaId: '',
                ProcessoSelecionadoId: '',
                flLoteUnico: '',
                dsNomeProcesso: '',
                cdProcessoNumero: '',
                dsProcesso: '',
                dtInicio: '',
                dtFinalizacaoEstimada: '',
                idProcessoWorkflowSelecionado: null,
                workflowPreferencialId: null,
                workflowCarregando: false,
                possuiWorkflows: false,

                camposInvalidos: {
                    dsNomeProcesso: false,
                    legislacaoSelecionadaId: false,
                    flLoteUnico: false,
                    ProcessoSelecionadoId: false,
                    cdProcessoNumero: false,
                    dtInicio: false,
                },

                // Itens
                itens: [],
                itemFilter: '',
                itemPage: 0,
                itemPageSize: 200,
                qtdRegistrosItem: 0,

                // detalhes / seleção
                detailsItem: {},
                detailsOpen: {},
                detailsByItem: {},
                selectedDetailRows: {},

                // lotes
                lotes: [],
                activeLote: 1,
                lotePorDetalhe: {},

                // Para o Form de itens
                unidadesMedida: [],
                unidadePorDetalhe: {},
                vlUnitPorDetalhe: {},
                vlUnitFmtPorDetalhe: {},

                qtdForm: {},
                detailsItemCheck : {},

                camposInvalidosQuantidades: {
                    unidadeMedida: false,
                    valorUnitario: false,
                    qtdForm: false,
                },

                processo: null,
                idProcessoElaboracao: null,
            }
        },

        computed: {
            hasMatchingWorkflow() {
                return this.possuiWorkflows
            },

            itensFiltrados() {
                const termo = (this.itemFilter || '').trim().toLowerCase()
                if (!termo) return this.itens

                return this.itens.filter(i => {
                    const a = String(i.idItem ?? '').toLowerCase()
                    const b = String(i.nmItem ?? '').toLowerCase()
                    const c = String(i.cdReferencia ?? '').toLowerCase()
                    const d = String(i.cdItem ?? '').toLowerCase()
                    return a.includes(termo) || b.includes(termo) || c.includes(termo) || d.includes(termo)
                })
            },

            itensSelecionadosFiltrados() {
                const termo = (this.itemFilter || '').trim().toLowerCase()
                const lote = (this.flLoteUnico === true ? 1 : this.activeLote)
                var distintos = new Set(Object.keys(this.detailsItem || {}).filter(x => x.endsWith(':' + lote)).map(k => k.split(':')[0]))
                if (!termo) return this.itens.filter(i => distintos.has(String(i.idItem)))

                return this.itens.filter(i => i.selecionado == true).filter(i => {
                    const a = String(i.idItem ?? '').toLowerCase()
                    const b = String(i.nmItem ?? '').toLowerCase()
                    const c = String(i.cdReferencia ?? '').toLowerCase()
                    const d = String(i.cdItem ?? '').toLowerCase()
                    return ( a.includes(termo) || b.includes(termo) || c.includes(termo) || d.includes(termo) )
                })
            },

            qtdItensSelecionados() {
                const obj = this.detailsItem || {}
                return new Set(Object.keys(obj).map(k => k.split(':')[0])).size
            },

            processoOk() {
                const nomeOk = !!this.dsNomeProcesso?.trim()
                const legOk = !!this.legislacaoSelecionadaId
                const tipoOk = !!this.ProcessoSelecionadoId
                const numeroOk = !!this.cdProcessoNumero?.trim()
                const loteOk = this.flLoteUnico === true || this.flLoteUnico === false
                const dtOk = !this.hasMatchingWorkflow || !!this.dtInicio

                return nomeOk && legOk && tipoOk && numeroOk && loteOk && dtOk
            },
        },

        watch: {
            legislacaoSelecionadaId() {
                this.handleWorkflowToggle()
            },
            ProcessoSelecionadoId() {
                this.handleWorkflowToggle()
            },

            flLoteUnico(newVal) {
                if (newVal === true) {
                    this.lotes = [1]
                    this.activeLote = 1
                    Object.keys(this.lotePorDetalhe || {}).forEach(k => {
                        this.$set(this.lotePorDetalhe, k, 1)
                    })
                }

                if (newVal === false) {
                    if (!this.lotes || this.lotes.length === 0) this.lotes = [1]
                    if (!this.activeLote || !this.lotes.includes(this.activeLote)) this.activeLote = this.lotes[0] || 1
                }
            },

            filtroRegistroId() {
                this.itemPage = 0
                this.itemFilter = ''
                this.resetSelecaoItens()
                this.getItens()
            },
        },

        mounted() {
            const el = document.getElementById('ModalCriarProcessoPorRegistro')
            const bs = window.bootstrap || window.Bootstrap
            if (el && bs?.Modal) this.bsModal = new bs.Modal(el, { focus: false })

            if (el) el.addEventListener('hidden.bs.modal', this.onModalHidden)
        },

        beforeDestroy() {
            const el = document.getElementById('ModalCriarProcessoPorRegistro')
            if (el) el.removeEventListener('hidden.bs.modal', this.onModalHidden)
        },

        methods: {
            abrir() {
                this.reset()
                Promise.all([this.getUnidadesMedida(), this.getRegistrosSelect(), this.getItens(), this.getProcesso()]).then(() => {
                    this.bsModal?.show?.()
                })
            },

            onModalHidden() {
                this.reset()
            },

            reset() {
                this.activeTab = 'processo'
                this.loading = false

                this.legislacaoSelecionadaId = ''
                this.ProcessoSelecionadoId = ''
                this.flLoteUnico = ''
                this.dsNomeProcesso = ''
                this.cdProcessoNumero = ''
                this.dsProcesso = ''
                this.dtInicio = ''
                this.dtFinalizacaoEstimada = ''
                this.idProcessoWorkflowSelecionado = null
                this.workflowPreferencialId = null
                this.workflowCarregando = false
                this.possuiWorkflows = false

                Object.keys(this.camposInvalidos).forEach(k => (this.camposInvalidos[k] = false))
                Object.keys(this.camposInvalidosQuantidades).forEach(k => (this.camposInvalidosQuantidades[k] = false))

                this.itens = []
                this.itemFilter = ''
                this.itemPage = 0
                this.qtdRegistrosItem = 0

                this.detailsOpen = {}
                this.detailsByItem = {}
                this.selectedDetailRows = {}

                this.detailsItem = {}

                if (!(this.idProcesso > 0)) {
                    this.lotes = [1]
                } else {
                    this.lotes = []
                }
                
                this.activeLote = 1
                this.lotePorDetalhe = {}

                this.processo = null
                this.idProcessoElaboracao = null

                this.unidadesMedida = []
                this.unidadePorDetalhe = { }
                this.vlUnitPorDetalhe = { }
                this.vlUnitFmtPorDetalhe = { }

                this.qtdForm = {}
                this.detailsItemCheck = {}
            },

            handleWorkflowToggle() {
                if (!this.hasMatchingWorkflow && (!this.idProcesso || this.idProcesso == 0 || this.idProcesso == null)) {
                    this.dtInicio = ''
                    this.camposInvalidos.dtInicio = false
                }
            },

            atualizarEstadoWorkflow(estado) {
                this.workflowCarregando = estado.loading === true
                this.possuiWorkflows = estado.hasWorkflows === true
                this.handleWorkflowToggle()
            },

            recarregarItens() {
                this.getItens()
            },

            async getItens() {
                this.loading = true
                try {
                    const res = await axios.get(`${urlApi}/RegistroNecessidade/GetRegistroNecessidadeItemAgrupado`, {
                        params: {
                            index: null,
                            take: null,
                            idRegistroNecessidade: this.filtroRegistroId || null,
                            somenteNaoUtilizados: true,
                        }
                    })

                    if (!res.data?.success) {
                        avisoToast(res.data?.msg || 'Erro ao carregar itens!', 'warning')
                        return
                    }

                    const grid = res.data.data
                    const rows = grid?.rows || []

                    this.itens = rows.map(x => x.registroNecessidadeItemAgrupado || x)
                    this.qtdRegistrosItem = Number(grid?.qtdRecords || 0)
                } catch (err) {
                    avisoErro(err.response?.data || err.message || 'Erro ao carregar itens!')
                } finally {
                    this.loading = false
                }
            },

            async getProcesso() {
                let $this = this;
                if (!$this.idProcesso || $this.idProcesso == 0 || $this.idProcesso == null) return

                const id = $this.idProcesso
                axios.get(`${urlApi}/Processo/Get/${id}`)
                    .then(res => {
                        if (res.data.success) {

                            $this.processo = res.data.data.processo;
                            let processoLegislacao = res.data.data.legislacao;
                            let processoTipoProcesso = res.data.data.tipoProcesso;

                            $this.idProcessoElaboracao = $this.processo.idProcesso;
                            $this.legislacaoSelecionadaId = processoLegislacao.idLegislacao;
                            $this.ProcessoSelecionadoId = processoTipoProcesso.idTipoProcesso;
                            $this.workflowPreferencialId = $this.processo.idProcessoWorkflow || null;
                            $this.idProcessoWorkflowSelecionado = $this.workflowPreferencialId;
                            //$this.flLoteUnico = true;
                            $this.dsNomeProcesso = $this.processo.dsNome;
                            $this.dsProcesso = $this.processo.dsProcesso;
                            $this.cdProcessoNumero = $this.processo.cdProcesso;
                            $this.dtInicio = ($this.processo.dtInicio ? $this.processo.dtInicio.split('T')[0]:'' ) ;
                            $this.dtFinalizacaoEstimada = ($this.processo.dtFinalizacaoEstimada ? $this.processo.dtFinalizacaoEstimada.split('T')[0] :'' ) ;

                            $this.getItensProcesso();
                            $this.VerificaLoteUnico();
                            $this.activeTab = 'itens'
                        } else {
                            avisoErro(res.data.msg || 'Erro ao carregar processo.')
                        }
                    })
                    .catch(err => {
                        if (err.response && err.response.data) {
                            avisoErro(err.response.data);
                            avisoToast("Erro ao carregar processo!", "warning");
                        } else {
                            avisoErro(err.message || "Erro desconhecido");
                        }
                    });
            },

            getItensProcesso() {
                let $this = this;
                axios.get(`${urlApi}/ProcessoItem/GetItensDetalhados/`, {
                    params: {
                        idProcesso: $this.idProcessoElaboracao,
                    }
                })
                    .then(res => {
                        if (res.data.success) {
                            let lstItens = res.data.data.rows;
                            if (lstItens.length > 0) {

                                $this.lotes = []
                                let lotes = new Set(lstItens.map(x => x.lote));
                                lotes.forEach(x => {
                                    $this.lotes.push(x);
                                })


                                this.itens.forEach(itemOpcoes => {
                                    lstItens.filter(x => x.idItem == itemOpcoes.idItem).forEach(item => {
                                        let k = $this.detailKeyLote(item.idItem, item.lote)
                                        $this.$set($this.detailsItem, k, true)
                                        $this.ensureDetailsLoaded(item.idItem)
                                    })
                                })
                           
                            }                           
                            
                        } else {
                            avisoErro(res.data.msg || 'Erro ao carregar itens do processo.')
                        }
                    })
                    .catch(err => {
                        if (err.response && err.response.data) {
                            avisoErro(err.response.data);
                            avisoToast("Erro ao carregar itens do processo!", "warning");
                        } else {
                            avisoErro(err.message || "Erro desconhecido");
                        }
                    });
            },


            VerificaLoteUnico() {
                let $this = this;
                return axios.get(`${urlApi}/ProcessoItem/VerificaLoteUnico`, { params: { idProcesso: this.idProcessoElaboracao } })
                    .then(res => {
                        if (res.data) {
                            var result = res.data.data;
                            $this.flLoteUnico = result.isLoteUnico;
                        } else {
                            avisoErro("Não foi possível verificar se o lote é único.");
                        }
                    })
                    .catch(() => {
                        avisoErro("Erro ao buscar configuração.");
                    });
            },

            // ===== detalhes do item =====
            isItemOpen(idItem) {
                const lote = (this.flLoteUnico === true ? 1 : this.activeLote)
                const k = this.detailKeyLote(idItem, lote)
                return !!this.detailsItem[k]
            },

            toggleItem(item) {
                const lote = (this.flLoteUnico === true ? 1 : this.activeLote)
                const k = this.detailKeyLote(item.idItem, lote)

                const idItem = item.idItem
                if (!idItem) return

                if (this.isItemOpen(idItem)) {
                    this.$delete(this.detailsItem, k)
                    return
                }

                this.$set(this.detailsItem, k, true)
                this.ensureDetailsLoaded(idItem)
            },

            isItemOpenDetail(idItem, idRegistroNecessidadeItem) {
                const lote = (this.flLoteUnico === true ? 1 : this.activeLote)
                const k = `${idItem}:${idRegistroNecessidadeItem}:${lote}`
                return !!this.detailsItemCheck[k]
            },

            toggleItemDetail(idItem, idRegistroNecessidadeItem) {
                const lote = (this.flLoteUnico === true ? 1 : this.activeLote)
                const k = `${idItem}:${idRegistroNecessidadeItem}:${lote}`
                if (!idItem) return

                if (this.isItemOpenDetail(idItem,idRegistroNecessidadeItem)) {
                    this.$delete(this.detailsItemCheck, k)
                    this.qtdForm[k] = 0
                    return
                }

                this.$set(this.detailsItemCheck, k, true)
            },

            isDetailsOpen(idItem) {
                return !!this.detailsOpen[idItem]
            },

            toggleDetails(item) {
                const idItem = item.idItem
                if (!idItem) return

                if (this.isDetailsOpen(idItem)) {
                    this.$delete(this.detailsOpen, idItem)
                    return
                }

                this.$set(this.detailsOpen, idItem, true)
                this.ensureDetailsLoaded(idItem)
            },

            getDetailsState(idItem) {
                return this.detailsByItem[idItem] || { loading: false, rows: [] }
            },

            async ensureDetailsLoaded(idItem) {
                if (this.detailsByItem[idItem]) return

                this.$set(this.detailsByItem, idItem, { loading: true, rows: [] })

                try {
                    const res = await axios.get(`${urlApi}/RegistroNecessidade/GetRegistroNecessidadeItemDetalhadoPorItem`, {
                        params: {
                            idItem,
                            idRegistroNecessidade: this.filtroRegistroId || null,
                            index: 0,
                            take: 500,
                            somenteNaoUtilizados: true,
                        }
                    })

                    if (!res.data?.success) {
                        avisoToast(res.data?.msg || 'Erro ao carregar detalhes do item!', 'warning')
                        this.$set(this.detailsByItem, idItem, { loading: false, rows: [] })
                        return
                    }

                    const grid = res.data.data
                    const rows = (grid?.rows || []).map(x => x.registroNecessidadeItem || x)

                    this.$set(this.detailsByItem, idItem, { loading: false, rows })
                } catch (err) {
                    avisoErro(err.response?.data || err.message || 'Erro ao carregar detalhes do item!')
                    this.$set(this.detailsByItem, idItem, { loading: false, rows: [] })
                }
            },

            async getUnidadesMedida() {
                try {
                    const res = await axios.get(`${urlApi}/CadastroItem/GetUnidadesMedida`)
                    if (res.data?.success) this.unidadesMedida = res.data.data || []
                    else this.unidadesMedida = (res.data?.data || [])
                } catch (e) {
                    this.unidadesMedida = []
                    avisoErro(e.response?.data || e.message || 'Erro ao carregar unidades de medida!')
                }
            },

            // ===== seleção (sempre por detalhe) =====
            isDetailSelected(idItem, idRegistroNecessidadeItem) {
                return !!(this.selectedDetailRows[idItem] && this.selectedDetailRows[idItem][idRegistroNecessidadeItem])
            },

            countSelectedDetails(idItem) {
                const obj = this.selectedDetailRows[idItem]
                return obj ? Object.keys(obj).length : 0
            },

            detailKey(idItem, idRegistroNecessidadeItem) {
                return `${idItem}:${idRegistroNecessidadeItem}`
            },
            detailKeyLote(idItem, lote) {
                return `${idItem}:${lote}`
            },

            getDetailLote(idItem, idRegistroNecessidadeItem) {
                if (this.flLoteUnico === true) return 1
                const k = this.detailKey(idItem, idRegistroNecessidadeItem)
                return Number(this.lotePorDetalhe[k]) || Number(this.activeLote) || 1
            },

            setDetailLote(idItem, idRegistroNecessidadeItem, lote) {
                const k = this.detailKey(idItem, idRegistroNecessidadeItem)
                const n = Number(lote) || 1
                this.$set(this.lotePorDetalhe, k, n)
            },

            onChangeDetailLote(idItem, idRegistroNecessidadeItem, lote) {
                this.setDetailLote(idItem, idRegistroNecessidadeItem, lote)
            },

            toggleDetailRow(idItem, row) {
                const idRow = row.idRegistroNecessidadeItem
                if (!idRow) return

                if (!this.selectedDetailRows[idItem]) this.$set(this.selectedDetailRows, idItem, {})
                const obj = this.selectedDetailRows[idItem]

                if (obj[idRow]) {
                    this.$delete(obj, idRow)

                    const k = this.detailKey(idItem, idRow)
                    if (this.lotePorDetalhe[k] !== undefined) this.$delete(this.lotePorDetalhe, k)
                    if (this.unidadePorDetalhe[k] !== undefined) this.$delete(this.unidadePorDetalhe, k)
                    if (this.vlUnitPorDetalhe[k] !== undefined) this.$delete(this.vlUnitPorDetalhe, k)
                    if (this.vlUnitFmtPorDetalhe[k] !== undefined) this.$delete(this.vlUnitFmtPorDetalhe, k)

                    if (Object.keys(obj).length === 0) this.$delete(this.selectedDetailRows, idItem)
                    return
                }

                this.$set(obj, idRow, true)

                if (this.flLoteUnico === true) this.setDetailLote(idItem, idRow, 1)
                else this.setDetailLote(idItem, idRow, this.activeLote || 1)
            },

            selectAllDetails(idItem) {
                const state = this.getDetailsState(idItem)
                if (!state?.rows?.length) return

                if (!this.selectedDetailRows[idItem]) this.$set(this.selectedDetailRows, idItem, {})
                const obj = this.selectedDetailRows[idItem]

                state.rows.forEach(r => {
                    const idRow = r?.idRegistroNecessidadeItem
                    if (!idRow) return

                    this.$set(obj, idRow, true)

                    if (this.flLoteUnico === true) this.setDetailLote(idItem, idRow, 1)
                    else this.setDetailLote(idItem, idRow, this.activeLote || 1)
                })
            },

            clearAllDetails(idItem) {
                const obj = this.selectedDetailRows[idItem]
                if (!obj) return

                Object.keys(obj).forEach(idRow => {
                    const k = this.detailKey(idItem, idRow)
                    if (this.lotePorDetalhe[k] !== undefined) this.$delete(this.lotePorDetalhe, k)
                })

                this.$delete(this.selectedDetailRows, idItem)
            },

            // ===== lotes =====
            setActiveLote(l) {
                if (this.flLoteUnico === true) return
                const n = Number(l) || 1
                this.activeLote = n
            },

            addLote() {
                const max = Math.max(...(this.lotes || [1]))
                const next = (Number.isFinite(max) ? max : 1) + 1
                this.lotes = [...this.lotes, next]
                this.activeLote = next
            },

            removeLote() {
                if (this.lotes.length <= 1) return

                let loteRemover = this.activeLote;
                this.lotes = this.lotes.filter(x => x != loteRemover)

                Object.keys(this.detailsItem).forEach(x => {
                    const idItem = x.split(':')[0]
                    const lote = x.split(':')[1]

                    if (lote == loteRemover) {
                        const detalhes = this.getDetailsState(idItem).rows;
                        detalhes.forEach(d => {
                            const k = `${idItem}:${d.idRegistroNecessidadeItem}:${lote}`
                            if (this.qtdForm[k] !== undefined) this.$delete(this.qtdForm, k)
                        })

                        if (this.unidadePorDetalhe[x] !== undefined) this.$delete(this.unidadePorDetalhe, x)
                        if (this.vlUnitFmtPorDetalhe[x] !== undefined) this.$delete(this.vlUnitFmtPorDetalhe, x)
                        if (this.vlUnitPorDetalhe[x] !== undefined) this.$delete(this.vlUnitPorDetalhe, x)
                        if (this.detailsItem[x] !== undefined) this.$delete(this.detailsItem, x)
                    }
                    
                });

                //if (this.lotePorDetalhe[k] !== undefined) this.$delete(this.lotePorDetalhe, k)
                //if (this.unidadePorDetalhe[k] !== undefined) this.$delete(this.unidadePorDetalhe, k)
                //if (this.vlUnitPorDetalhe[k] !== undefined) this.$delete(this.vlUnitPorDetalhe, k)
                //if (this.vlUnitFmtPorDetalhe[k] !== undefined) this.$delete(this.vlUnitFmtPorDetalhe, k)

                //if (Object.keys(obj).length === 0) this.$delete(this.selectedDetailRows, idItem)
            },

            countDetailsInLote(l) {
                const lote = Number(l) || 1
                let count = 0

                Object.keys(this.selectedDetailRows || {}).forEach(idItem => {
                    const obj = this.selectedDetailRows[idItem] || {}
                    Object.keys(obj).forEach(idRow => {
                        const k = this.detailKey(idItem, idRow)
                        const v = Number(this.lotePorDetalhe[k]) || 1
                        if (v === lote) count++
                    })
                })

                return count
            },

            // ===== validação e salvar =====
            validarProcesso() {
                if (this.workflowCarregando) {
                    avisoToast('Aguarde o carregamento dos workflows.', 'warning')
                    return false
                }
                this.camposInvalidos.dsNomeProcesso = !this.dsNomeProcesso?.trim()
                this.camposInvalidos.legislacaoSelecionadaId = !this.legislacaoSelecionadaId
                this.camposInvalidos.ProcessoSelecionadoId = !this.ProcessoSelecionadoId
                this.camposInvalidos.cdProcessoNumero = !this.cdProcessoNumero?.trim()
                this.camposInvalidos.flLoteUnico = this.flLoteUnico !== true && this.flLoteUnico !== false
                this.camposInvalidos.dtInicio = this.hasMatchingWorkflow && !this.dtInicio
                const workflowInvalido = this.possuiWorkflows && !this.idProcessoWorkflowSelecionado

                const invalido = Object.values(this.camposInvalidos).some(Boolean) || workflowInvalido
                if (invalido) {
                    avisoToast('Preencha todos os campos obrigatórios do processo para continuar.', 'warning')
                    return false
                }
                return true
            },

            async irParaItens() {
                if (!this.validarProcesso()) {
                    this.activeTab = 'processo'
                    return
                }
                this.itemFilter = '';
                const payload = {
                    idProcesso: this.idProcessoElaboracao,
                    idLegislacao: Number(this.legislacaoSelecionadaId),
                    idTipoProcesso: Number(this.ProcessoSelecionadoId),
                    idProcessoWorkflow: this.idProcessoWorkflowSelecionado,
                    flLoteUnico: this.flLoteUnico,
                    dsNome: this.dsNomeProcesso,
                    dsProcesso: this.dsProcesso,
                    cdProcesso: this.cdProcessoNumero,
                    dtInicio: this.hasMatchingWorkflow ? this.dtInicio : null,
                    dtFinalizacaoEstimada: this.dtFinalizacaoEstimada || null,
                };

                try {
                    const res = await axios.post(`${urlApi}/Processo/PostElaboracao`, payload);

                    if (!res.data?.success) {
                        const erroMsg = res.data?.msg || "Erro ao salvar processo!";
                        avisoErro(erroMsg);
                        avisoToast(erroMsg, "warning");
                        return;
                    }
                    const novoId =
                        res.data?.data ??
                        (() => {
                            const loc = res.headers?.location;
                            const m = loc ? /\/(\d+)$/.exec(loc) : null;
                            return m ? Number(m[1]) : null;
                        })();

                    if (this.idProcessoElaboracao == 0) {
                        avisoToast("Processo criado com sucesso!", "success");
                    } else {
                        avisoToast("Processo salvo com sucesso!", "success");
                    }
                    this.$emit('refreshGrid')

                    if (novoId) {
                        this.idProcessoElaboracao = novoId;
                        this.activeTab = 'itens'
                    } else {
                        console.warn('ID do processo não encontrado.');
                    }                    

                } catch (err) {
                    if (err.response?.data) {
                        const response = err.response.data;
                        const mensagem = response.msg || "Erro ao salvar processo!";
                        const motivo = response.errors?.[0];

                        if (mensagem === "Limite de utilizações") {
                            avisoErro(mensagem + '. ' + motivo);
                        } else {
                            avisoErro(mensagem);
                        }
                    } else {
                        avisoErro(err.message || "Erro desconhecido");
                    }
                }

                
            },

            async irParaQuantidades() {
                if (!this.validarProcesso()) {
                    this.activeTab = 'processo'
                    return
                }
                this.itemFilter = '';
                const obj = this.detailsItem || {}
                var lstItens = new Set(Object.keys(obj).map(k => k.split(':')[0]))

                if (lstItens.size == 0) {
                    avisoToast('Selecione ao menos um item para continuar.', 'warning')
                    return false
                }

                const payload = {
                    idProcesso: this.idProcessoElaboracao,
                    idLegislacao: Number(this.legislacaoSelecionadaId),
                    idTipoProcesso: Number(this.ProcessoSelecionadoId),
                    idProcessoWorkflow: this.idProcessoWorkflowSelecionado,
                    flLoteUnico: this.flLoteUnico,
                    dsNome: this.dsNomeProcesso,
                    dsProcesso: this.dsProcesso,
                    cdProcesso: this.cdProcessoNumero,
                    dtInicio: this.hasMatchingWorkflow ? this.dtInicio : null,
                    dtFinalizacaoEstimada: this.dtFinalizacaoEstimada || null,
                };

                const itensPayload = []
                Object.keys(this.detailsItem).forEach(x => {
                    const idItem = x.split(':')[0]
                    const lote = x.split(':')[1]
                    
                    itensPayload.push({
                        idItem:idItem,
                        lote:lote
                    })
                })

                try {
                    const res = await axios.post(`${urlApi}/ProcessoItem/PostElaboracaoItens`, { processo: payload, itens: itensPayload });

                    if (!res.data?.success) {
                        const erroMsg = res.data?.msg || "Erro ao salvar os itens!";
                        avisoErro(erroMsg);
                        avisoToast(erroMsg, "warning");
                        return;
                    }
                    
                    avisoToast("Itens salvos com sucesso!", "success");

                    this.activeTab = 'quantidades'

                } catch (err) {
                    if (err.response?.data) {
                        const response = err.response.data;
                        const mensagem = response.msg || "Erro ao salvar os itens!";
                        const motivo = response.errors?.[0];

                        if (mensagem === "Limite de utilizações") {
                            avisoErro(mensagem + '. ' + motivo);
                        } else {
                            avisoErro(mensagem);
                        }
                    } else {
                        avisoErro(err.message || "Erro desconhecido");
                    }
                }

                lstItens.forEach(item => {
                    this.ensureDetailsLoaded(item.idItem);
                });                
            },

            async getRegistrosSelect() {
                try {
                    const res = await axios.get(`${urlApi}/RegistroNecessidade/GetRegistroNecessidade`, {
                        params: { index: 0, take: 500 }
                    })

                    if (res.data?.success) {
                        const grid = res.data.data
                        const rows = grid?.rows || []
                        this.registros = rows.map(x => x.registroNecessidade || x)
                    } else {
                        this.registros = []
                    }
                } catch (err) {
                    this.registros = []
                    avisoToast('Erro ao carregar registros para filtro.', 'warning')
                }
            },


            validar() {
                if (!this.validarProcesso()) {
                    this.activeTab = 'processo'
                    return false
                }

                const obj = this.detailsItem || {}
                var lstItens = new Set(Object.keys(obj).map(k => k.split(':')[0]))

                if (lstItens.size == 0) {
                    avisoToast('Selecione ao menos um item para continuar.', 'warning')
                    return false
                }
                let result = true
                Object.keys(obj).forEach(x => {
                    const idItem = x.split(':')[0]
                    const lote = x.split(':')[1]

                    const unidadeMedida = Number(this.unidadePorDetalhe[x]) || 0;
                    const valorInformado = this.vlUnitPorDetalhe[x];
                    const valorVazio = valorInformado === undefined || valorInformado === null || valorInformado === '';
                    const valorInvalido = valorVazio || !Number.isFinite(Number(valorInformado)) || Number(valorInformado) < 0;

                    const detalhes = this.getDetailsState(idItem).rows;
                    let flDetalhes = false
                    let temRegistroSelecionado = false
                    detalhes.forEach(d => {
                        const k = `${idItem}:${d.idRegistroNecessidadeItem}:${lote}`

                        if (this.detailsItemCheck[k]) {
                            temRegistroSelecionado = true
                            let qtdForm = Number(this.qtdForm[k]) || 0
                            if (qtdForm > 0) flDetalhes = true
                        }                            
                    })

                    this.camposInvalidosQuantidades.unidadeMedida = this.camposInvalidosQuantidades.unidadeMedida || unidadeMedida <= 0;
                    this.camposInvalidosQuantidades.valorUnitario = this.camposInvalidosQuantidades.valorUnitario || valorInvalido;
                    this.camposInvalidosQuantidades.qtdForm = this.camposInvalidosQuantidades.qtdForm || flDetalhes

                    if (unidadeMedida <= 0 || valorInvalido || !flDetalhes || !temRegistroSelecionado) result = false
                })
                

                if (!result) {
                    avisoToast('Para cada item selecionado, informe Unidade de Medida, Valor Unitário e Quantidade Utilizada.', 'warning')
                    return false
                }

                // --------------
                //const idsItens = Object.keys(this.selectedDetailRows || {})
                //if (idsItens.length === 0) {
                //    avisoToast('Selecione ao menos 1 registro/setor em algum item.', 'warning')
                //    this.activeTab = 'itens'
                //    return false
                //}

                //let ok = true
                //Object.keys(this.selectedDetailRows || {}).forEach(idItem => {
                //    const obj = this.selectedDetailRows[idItem] || {}
                //    Object.keys(obj).forEach(idRow => {
                //        const k = this.detailKey(idItem, idRow)
                //        const un = Number(this.unidadePorDetalhe[k]) || 0
                //        const vu = Number(this.vlUnitPorDetalhe[k]) || 0
                //        if (un <= 0 || vu <= 0) ok = false
                //    })
                //})

                //if (!ok) {
                //    avisoToast('Para cada detalhe selecionado, informe Unidade de Medida e Valor Unitário.', 'warning')
                //    return false
                //}

                //let allOk = true
                //idsItens.forEach(idItem => {
                //    if (this.countSelectedDetails(idItem) === 0) allOk = false
                //})

                //if (!allOk) {
                //    avisoToast('Para cada item selecionado, marque ao menos 1 registro/setor nos detalhes.', 'warning')
                //    this.activeTab = 'itens'
                //    return false
                //}

                return true
            },

            async salvar() {

                let $this = this;
                if (!this.validar()) return

                const itensPayload = []

                Object.keys(this.detailsItem).forEach(x => {
                    const idItem = x.split(':')[0]
                    const lote = x.split(':')[1]
                    const state = this.getDetailsState(idItem)
                //    const selectedObj = this.selectedDetailRows[idItem] || {}

                //    // somente detalhes marcados
                    const linhasSelecionadas = (state.rows || [])
                        //        .filter(r => !!selectedObj[r.idRegistroNecessidadeItem])
                        .map(r => {
                            const idRow = r.idRegistroNecessidadeItem
                            //const k = this.detailKey(idItem, idRow)
                            const k = `${idItem}:${idRow}:${lote}`
                            let qtdForm = Number(this.qtdForm[k]) || 0

                            return {
                                lote,
                                payload: {
                                    idRegistroNecessidadeItem: idRow,
                                    idRegistroNecessidade: r.idRegistroNecessidade,
                                    idSetor: r.idSetorItem || r.idSetor || null,
                                    qtd: Number(qtdForm) || 0,
                                    idUnidadeMedida: Number($this.unidadePorDetalhe[x]) || 0,
                                    vlUnitarioItem: this.vlUnitPorDetalhe[x],
                                    vlTotalItem: (Number(qtdForm) || 0) * this.vlUnitPorDetalhe[x],
                                }
                            }
                        }).filter(x => x.payload.qtd > 0);

                    const grupos = {}
                    linhasSelecionadas.forEach(x => {
                        const l = Number(x.lote) || 1
                        if (!grupos[l]) grupos[l] = []
                        grupos[l].push(x.payload)
                    })

                    Object.keys(grupos).forEach(loteStr => {
                        const lote = Number(loteStr) || 1
                        itensPayload.push({
                            idItem,
                            lote,
                            detalhes: grupos[lote],
                        })
                    })
                })

                const payload = {
                    processo: {
                        idProcesso: this.idProcessoElaboracao,
                        idLegislacao: Number(this.legislacaoSelecionadaId),
                        idTipoProcesso: Number(this.ProcessoSelecionadoId),
                        idProcessoWorkflow: this.idProcessoWorkflowSelecionado,
                        flLoteUnico: this.flLoteUnico,
                        dsNome: this.dsNomeProcesso,
                        dsProcesso: this.dsProcesso,
                        cdProcesso: this.cdProcessoNumero,
                        dtInicio: this.hasMatchingWorkflow ? this.dtInicio : null,
                        dtFinalizacaoEstimada: this.dtFinalizacaoEstimada || null,
                    },
                    itens: itensPayload,
                }

                this.loading = true
                try {
                    const res = await axios.post(`${urlApi}/RegistroNecessidade/PostFromRegistroNecessidade`, payload)
                    console.log(res)
                    if (!res.data?.success) {
                        avisoErro(res.data?.msg || 'Erro ao salvar processo!')
                        return
                    }

                    avisoToast('Processo criado com sucesso!', 'success')
                    this.bsModal?.hide?.()
                    this.$emit('saved', res.data?.data || null)
                } catch (err) {
                    const apiData = err.response?.data
                    const msgBase =
                        apiData?.msg ||
                        apiData?.title || // caso venha ProblemDetails do ASP.NET
                        err.message ||
                        'Erro ao salvar!'
                    let detalhes = ''
                    if (Array.isArray(apiData?.errors)) {
                        detalhes = apiData.errors.join(' ')
                    } else if (apiData?.errors && typeof apiData.errors === 'object') {
                        // validação de model state (errors como objeto)
                        detalhes = Object.values(apiData.errors).flat().join(' ')
                    }
                    avisoErro([msgBase, detalhes].filter(Boolean).join(' - '))
                } finally {
                    this.loading = false
                }
            },
            
            // ===== helpers =====
            formatarData(dataISO) {
                if (!dataISO) return ''
                const d = new Date(dataISO)
                return d.toLocaleDateString('pt-BR')
            },

            formatarQtd(v) {
                if (v === null || v === undefined) return '0'
                try { return Number(v).toLocaleString('pt-BR') } catch { return String(v) }
            },

            formatarUnidade(um) {
                return `${um.cdUnidadeMedida}`
            },

            getDetailUnidade(idItem) {
                //const k = this.detailKey(idItem, idRegistroNecessidadeItem)
                //const v = this.unidadePorDetalhe[k]
                //return v === undefined || v === null ? '' : Number(v)

                const lote = (this.flLoteUnico === true ? 1 : this.activeLote)
                const k = this.detailKeyLote(idItem, lote)
                const v = this.unidadePorDetalhe[k]
                return v === undefined || v === null ? '' : Number(v)
            },

            onChangeDetailUnidade(idItem, val) {
                //const k = this.detailKey(idItem, idRegistroNecessidadeItem)
                //const n = Number(val) || ''
                //this.$set(this.unidadePorDetalhe, k, n)
                const lote = (this.flLoteUnico === true ? 1 : this.activeLote)
                const k = this.detailKeyLote(idItem, lote)
                const n = Number(val) || ''
                this.$set(this.unidadePorDetalhe, k, n)
            },

            getDetailVlUnitFmt(idItem) {
                //const k = this.detailKey(idItem, idRegistroNecessidadeItem)
                //return this.vlUnitFmtPorDetalhe[k] ?? ''
                const lote = (this.flLoteUnico === true ? 1 : this.activeLote)
                const k = this.detailKeyLote(idItem, lote)
                return this.vlUnitFmtPorDetalhe[k] ?? ''
            },

            getDetailVlUnit(idItem) {
                //const k = this.detailKey(idItem, idRegistroNecessidadeItem)
                //return Number(this.vlUnitPorDetalhe[k]) || 0
                const lote = (this.flLoteUnico === true ? 1 : this.activeLote)
                const k = this.detailKeyLote(idItem, lote)
                return Number(this.vlUnitPorDetalhe[k]) || 0
            },

            onInputDetailVlUnit(idItem, event) {
                const digits = (event.target.value || '').replace(/\D/g, '')
                const num = (parseInt(digits || '0', 10) / 100)
                const lote = (this.flLoteUnico === true ? 1 : this.activeLote)
                const k = this.detailKeyLote(idItem, lote)

                const v = isNaN(num) ? 0 : num
                this.$set(this.vlUnitPorDetalhe, k, v)
                this.$set(this.vlUnitFmtPorDetalhe, k, v.toLocaleString('pt-BR', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                }))
            },

            replicaVlUit(idItem, valor) {
                const lote = (this.flLoteUnico === true ? 1 : this.activeLote)
                const k = this.detailKeyLote(idItem, lote)
                this.$set(this.vlUnitPorDetalhe, k, valor)
                this.$set(this.vlUnitFmtPorDetalhe, k, this.formatarMoeda(valor))
            },

            getDetailQtdForm(idItem, idRegistroNecessidadeItem) {
                const lote = (this.flLoteUnico === true ? 1 : this.activeLote)
                const k = `${idItem}:${idRegistroNecessidadeItem}:${lote}`
                return Number(this.qtdForm[k]) || 0
            },

            onInputDetailQtdForm(idItem, idRegistroNecessidadeItem, event) {
                const lote = (this.flLoteUnico === true ? 1 : this.activeLote)
                const k = `${idItem}:${idRegistroNecessidadeItem}:${lote}`
                const n = Number(event.target.value) || ''
                this.$set(this.qtdForm, k, n)
            },

            getDetailTotal(idItem) {
                const qtd = Number(this.getTotalUtilizado(idItem)) || 0
                const vlUnit = this.getDetailVlUnit(idItem)
                return qtd * vlUnit
            },

            formatarMoeda(v) {
                const n = Number(v) || 0
                return n.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
            },

            resetSelecaoItens() {
                this.detailsOpen = {}
                this.detailsByItem = {}
                this.selectedDetailRows = {}
                this.lotePorDetalhe = {}
                this.unidadePorDetalhe = {}
                this.vlUnitPorDetalhe = {}
                this.vlUnitFmtPorDetalhe = {}
            },
            utilizarTotalRequisitado(idItem, d) {
                const state = this.getDetailsState(idItem)
                if (!state?.rows?.length) return

                const lote = (this.flLoteUnico === true ? 1 : this.activeLote)

                const k = `${idItem}:${d.idRegistroNecessidadeItem}:${lote}`
                if (!this.detailsItemCheck[k]) {
                    avisoToast('Selecione o registro para utilizar o total requisitado','warning');
                    return
                }

                state.rows.forEach(r => {
                    if (r.idRegistroNecessidadeItem == d.idRegistroNecessidadeItem) {
                        const k = `${idItem}:${r.idRegistroNecessidadeItem}:${lote}`
                        this.$set(this.qtdForm, k, r.qtdItem)
                    }
                })
            },
            getTotalUtilizado(idItem) {
                let total = 0;
                const state = this.getDetailsState(idItem)
                if (!state?.rows?.length) return total

                const lote = (this.flLoteUnico === true ? 1 : this.activeLote)
                state.rows.forEach(r => {
                    const k = `${idItem}:${r.idRegistroNecessidadeItem}:${lote}`
                    total += Number(this.qtdForm[k] ? this.qtdForm[k] : 0);
                })
                return total
            },
        }
    }
</script>


<style scoped>
    .modal-grande {
        width: 100% !important;
        max-width: calc(100vw - 40px) !important;
        margin: auto;
        margin-top: 20px;
        padding: 0 12px;
    }

    .modern-modal .modal-modern-content {
        border-radius: 20px;
        background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
        box-shadow: 0 20px 60px rgba(15, 23, 42, 0.18);
        position: relative;
    }

    .modal-modern-header {
        display: flex;
        align-items: flex-start;
        gap: 18px;
        padding: 32px 32px 20px;
        position: relative;
        z-index: 1;
    }

        .modal-modern-header::after {
            content: '';
            position: absolute;
            bottom: -1px;
            left: 32px;
            right: 32px;
            height: 1px;
            background: linear-gradient(90deg, transparent, rgba(148, 163, 184, 0.35), transparent);
        }

        .modal-modern-header .header-icon {
            width: 64px;
            height: 64px;
            border-radius: 18px;
            display: flex;
            align-items: center;
            justify-content: center;
            background: linear-gradient(135deg, rgba(37, 99, 235, 0.12) 0%, rgba(16, 185, 129, 0.12) 100%);
            color: #2563eb;
            flex-shrink: 0;
        }

        .modal-modern-header .header-text {
            flex: 1;
            display: flex;
            flex-direction: column;
            gap: 6px;
        }

            .modal-modern-header .header-text h2 {
                margin: 0;
                font-size: 24px;
                font-weight: 700;
                color: #0f172a;
            }

            .modal-modern-header .header-text p {
                margin-top: 6px;
                margin-bottom: 0;
                color: #475569;
                font-size: 14px;
                max-width: 420px;
                line-height: 1.4;
            }

    .header-status {
        display: flex;
        align-items: center;
        gap: 12px;
        flex-wrap: wrap;
    }

    .tabs-row {
        display: flex;
        gap: 8px;
        background: rgba(248, 250, 252, 0.9);
        border: 1px solid rgba(226, 232, 240, 0.8);
        border-radius: 12px;
        padding: 4px;
    }

    .tab-btn {
        padding: 10px 20px;
        border-radius: 8px;
        font-weight: 600;
        font-size: 14px;
        border: none;
        cursor: pointer;
        transition: all 0.2s ease;
        background: transparent;
        color: #64748b;
    }

        .tab-btn:hover {
            background: rgba(59, 130, 246, 0.1);
            color: #2563eb;
        }

        .tab-btn.active {
            background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);
            color: #ffffff;
            box-shadow: 0 4px 12px rgba(37, 99, 235, 0.3);
        }

        .tab-btn.blocked {
            opacity: 0.5;
            cursor: not-allowed;
            position: relative;
        }

        .tab-btn.blocked:hover {
            background: transparent;
            color: #64748b;
        }

    .modal-modern-body {
        padding: 28px 32px;
        display: flex;
        flex-direction: column;
        gap: 20px;
    }

    .form-grid {
        display: grid;
        gap: 18px;
    }

    .form-grid-3 {
        grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
    }

    .form-grid-2 {
        grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
    }

    .form-group {
        display: flex;
        flex-direction: column;
        gap: 4px;
    }

    .form-group-inline {
        display: flex;
        align-items: center;
        gap: 16px;
        flex-wrap: wrap;
    }

        .form-group-inline .info-chip {
            display: inline-flex;
            align-items: flex-start;
            gap: 8px;
            padding: 12px 16px;
            border-radius: 12px;
            background: rgba(37, 99, 235, 0.08);
            color: #1e3a8a;
            font-size: 13px;
            line-height: 1.4;
            max-width: 380px;
        }

    .form-textarea {
        min-height: 110px;
        resize: vertical;
    }

    .modern-modal .form-control {
        border-radius: 12px;
        border: 2px solid rgba(148, 163, 184, 0.25);
        padding: 12px 16px;
        font-size: 14px;
        color: #1f2937;
        transition: border-color 0.2s ease, box-shadow 0.2s ease;
    }

        .modern-modal .form-control:focus {
            border-color: rgba(37, 99, 235, 0.6);
            box-shadow: 0 0 0 4px rgba(37, 99, 235, 0.1);
            background-color: #ffffff;
        }

    .modern-modal select.form-control {
        appearance: none;
        -webkit-appearance: none;
        -moz-appearance: none;
        background-color: #ffffff;
        background-image: url("data:image/svg+xml,%3Csvg width='14' height='9' viewBox='0 0 14 9' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 1.5L7 7.5L13 1.5' stroke='%23838B99' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
        background-repeat: no-repeat;
        background-position: right 16px center;
        background-size: 14px 9px;
        padding-right: 46px;
        cursor: pointer;
    }

    .modern-modal .form-label {
        font-weight: 600;
        color: #0f172a;
        font-size: 13px;
        letter-spacing: 0.3px;
        text-transform: uppercase;
        margin-bottom: 2px;
        margin-top: 12px;
    }

    .modern-modal small.text-muted {
        color: #64748b;
    }

    .form-control-sm {
        padding: 8px 12px;
        font-size: 13px;
    }

    .form-grid {
        display: grid;
        gap: 18px;
    }

    .form-grid-2 {
        grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    }

    .form-grid-3 {
        grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
    }

    .form-actions {
        display: flex;
        flex-wrap: wrap;
        gap: 12px;
        justify-content: flex-end;
        margin-top: 8px;
    }


    .custom-table-header {
        margin-bottom: 18px;
    }

    .header-toolbar {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 20px;
        flex-wrap: wrap;
        padding: 16px 20px;
        background: linear-gradient(135deg, rgba(248, 250, 252, 0.95) 0%, rgba(241, 245, 249, 0.98) 100%);
        border: 1px solid rgba(226, 232, 240, 0.9);
        border-radius: 16px;
        box-shadow: 0 4px 16px rgba(148, 163, 184, 0.08);
    }

    .left-tools {
        display: flex;
        align-items: center;
        gap: 14px;
        flex-wrap: wrap;
        flex: 1;
        min-width: 0;
    }

    .right-tools {
        display: flex;
        align-items: center;
        gap: 12px;
        flex-wrap: wrap;
        flex-shrink: 0;
    }

    .header-toolbar-lotes .right-tools-lotes {
        flex: 1;
        justify-content: flex-end;
    }

    .header-toolbar-lotes .totals {
        align-items: center;
        gap: 10px;
    }

    /* Filter Select - estilo unificado */
    .filter-select {
        display: flex;
        flex-direction: column;
        gap: 6px;
        min-width: 180px;
    }

    .filter-label {
        font-size: 11px;
        font-weight: 700;
        text-transform: uppercase;
        letter-spacing: 0.5px;
        color: #64748b;
        margin: 0;
        line-height: 1;
    }

    .filter-select-input {
        height: 42px;
        padding: 0 14px 0 16px;
        border-radius: 12px;
        border: 2px solid rgba(148, 163, 184, 0.3);
        background: #ffffff;
        font-size: 14px;
        color: #1e293b;
        font-weight: 500;
        transition: border-color 0.2s ease, box-shadow 0.2s ease;
        appearance: none;
        -webkit-appearance: none;
        -moz-appearance: none;
        background-image: url("data:image/svg+xml,%3Csvg width='12' height='8' viewBox='0 0 12 8' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 1.5L6 6.5L11 1.5' stroke='%2364748b' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
        background-repeat: no-repeat;
        background-position: right 14px center;
        background-size: 12px 8px;
        padding-right: 40px;
        cursor: pointer;
    }

    .filter-select-input:hover {
        border-color: rgba(148, 163, 184, 0.5);
    }

    .filter-select-input:focus {
        border-color: rgba(37, 99, 235, 0.6);
        box-shadow: 0 0 0 4px rgba(37, 99, 235, 0.12);
        outline: none;
    }

    /* Search Box - com ícone */
    .search-box {
        position: relative;
        flex: 1;
        min-width: 220px;
        max-width: 340px;
    }

    .search-box .search-icon {
        position: absolute;
        left: 16px;
        top: 50%;
        transform: translateY(-50%);
        color: #94a3b8;
        pointer-events: none;
        transition: color 0.2s ease;
    }

    .search-box:focus-within .search-icon {
        color: #2563eb;
    }

    .search-input {
        width: 100%;
        height: 42px;
        padding: 0 16px 0 44px;
        border-radius: 12px;
        border: 2px solid rgba(148, 163, 184, 0.3);
        font-size: 14px;
        transition: border-color 0.2s ease, box-shadow 0.2s ease;
        background: #ffffff;
        color: #1e293b;
    }

    .search-input::placeholder {
        color: #94a3b8;
    }

    .search-input:hover {
        border-color: rgba(148, 163, 184, 0.5);
    }

    .search-input:focus {
        border-color: rgba(37, 99, 235, 0.6);
        box-shadow: 0 0 0 4px rgba(37, 99, 235, 0.12);
        outline: none;
    }

    /* Botão de atualizar na toolbar */
    .toolbar-btn {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        gap: 8px;
        height: 42px;
        padding: 0 18px;
        border-radius: 12px;
        font-weight: 600;
        font-size: 13px;
        border: none;
        cursor: pointer;
        transition: all 0.2s ease;
        white-space: nowrap;
    }

    .toolbar-btn-refresh {
        background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);
        color: #ffffff;
        box-shadow: 0 4px 12px rgba(37, 99, 235, 0.25);
    }

    .toolbar-btn-refresh:hover:not(:disabled) {
        transform: translateY(-1px);
        box-shadow: 0 6px 16px rgba(37, 99, 235, 0.35);
    }

    .toolbar-btn:disabled {
        opacity: 0.6;
        cursor: not-allowed;
    }

    .totals {
        display: flex;
        align-items: center;
        gap: 10px;
        flex-wrap: wrap;
    }

    .total-chip {
        padding: 8px 14px;
        background: linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%);
        border: 2px solid #bfdbfe;
        border-radius: 8px;
        font-size: 13px;
        font-weight: 600;
        color: #1e40af;
        cursor: pointer;
        transition: all 0.2s ease;
        border: 2px solid #bfdbfe;
    }

    .total-chip:hover {
        background: linear-gradient(135deg, #dbeafe 0%, #bfdbfe 100%);
        transform: translateY(-1px);
        box-shadow: 0 4px 12px rgba(37, 99, 235, 0.2);
    }

    .total-chip.chip-active {
        background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);
        border-color: #1e40af;
        color: #ffffff;
        box-shadow: 0 4px 12px rgba(37, 99, 235, 0.3);
    }

    .total-chip.chip-active:hover {
        background: linear-gradient(135deg, #1d4ed8 0%, #1e3a8a 100%);
    }

    .table-wrapper {
        margin-top: 4px;
    }

    .modern-table .custom-table {
        width: 100%;
        border-collapse: collapse;
        border-radius: 16px;
        overflow: hidden;
        border: 1px solid rgba(148, 163, 184, 0.2);
    }

        .modern-table .custom-table thead {
            background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
        }

        .modern-table .custom-table th,
        .modern-table .custom-table td {
            padding: 14px 18px;
            border-bottom: 1px solid rgba(148, 163, 184, 0.16);
            font-size: 14px;
            color: #1e293b;
        }

        .modern-table .custom-table th {
            font-weight: 700;
            text-transform: uppercase;
            font-size: 12px;
            letter-spacing: 0.45px;
        }

        .modern-table .custom-table tbody tr:hover {
            background: rgba(59, 130, 246, 0.08);
        }

        .modern-table .custom-table.custom-table-quantidades tbody tr {
            background: rgba(59, 130, 246, 0.08);
        }
        .modern-table .custom-table.custom-table-detalhes tbody tr, .modern-table .custom-table.custom-table-detalhes thead tr {
            background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
        }
    

    .id-badge {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        padding: 6px 12px;
        border-radius: 10px;
        font-weight: 700;
        font-size: 13px;
        background: linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%);
        border: 1px solid rgba(59, 130, 246, 0.3);
        color: #1d4ed8;
    }

    .item-name {
        font-weight: 600;
        color: #0f172a;
        font-size: 14px;
        margin-bottom: 4px;
    }

    .item-details {
        font-size: 13px;
        color: #64748b;
    }

    .number-badge {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        padding: 6px 12px;
        border-radius: 10px;
        font-weight: 700;
        font-size: 13px;
        background: linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%);
        border: 1px solid rgba(59, 130, 246, 0.3);
        color: #1d4ed8;
    }

    .pill {
        display: inline-flex;
        align-items: center;
        padding: 4px 12px;
        border-radius: 999px;
        font-size: 12px;
        font-weight: 600;
        border: 1px solid transparent;
    }

    .pill-ok {
        background: rgba(16, 185, 129, 0.12);
        color: #059669;
        border-color: rgba(16, 185, 129, 0.25);
    }

    .pill-off {
        background: rgba(239, 68, 68, 0.12);
        color: #dc2626;
        border-color: rgba(239, 68, 68, 0.25);
    }

    .action-btn {
        display: inline-flex;
        align-items: center;
        gap: 6px;
        padding: 8px 14px;
        border-radius: 10px;
        font-weight: 600;
        font-size: 13px;
        border: 2px solid transparent;
        cursor: pointer;
        transition: transform 0.2s ease, box-shadow 0.2s ease;
        background: #f8fafc;
        color: #1f2937;
    }

        .action-btn:hover {
            transform: translateY(-2px);
            box-shadow: 0 8px 18px rgba(15, 23, 42, 0.12);
        }

    .action-btn-view {
        background: rgba(59, 130, 246, 0.12);
        color: #2563eb;
        border-color: rgba(59, 130, 246, 0.35);
    }

        .action-btn-view:hover {
            background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);
            color: #ffffff;
            border-color: transparent;
        }

    .section-card {
        background: linear-gradient(135deg, rgba(255, 255, 255, 0.9) 0%, rgba(248, 250, 252, 0.95) 100%);
        border: 1px solid rgba(226, 232, 240, 0.8);
        border-radius: 18px;
        padding: 20px 22px;
        box-shadow: 0 12px 28px rgba(148, 163, 184, 0.15);
        display: flex;
        flex-direction: column;
        gap: 18px;
    }

    .details-card {
        padding: 12px;
        border-radius: 10px;
    }

    .dependency-toolbar {
        background: rgba(248, 250, 252, 0.9);
        border: 1px solid rgba(226, 232, 240, 0.8);
        border-radius: 16px;
        padding: 16px 18px;
        display: flex;
        flex-wrap: wrap;
        gap: 16px;
        align-items: center;
        justify-content: space-between;
    }

    .toolbar-text {
        color: #475569;
        font-size: 13px;
        max-width: 460px;
        line-height: 1.5;
    }

    .toolbar-actions {
        display: flex;
        align-items: center;
        gap: 14px;
        flex-wrap: wrap;
    }

    .empty-state {
        padding: 32px 24px;
        text-align: center;
    }

    .empty-content {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 12px;
    }

    .empty-icon {
        color: #94a3b8;
    }

    .empty-title {
        margin: 0;
        font-size: 18px;
        font-weight: 700;
        color: #0f172a;
    }

    .empty-description {
        margin: 0;
        font-size: 14px;
        color: #64748b;
    }

    .modal-modern-footer {
        padding: 0 32px 32px;
    }

    .btn-close-modern {
        position: absolute;
        top: 18px;
        right: 18px;
        width: 44px;
        height: 44px;
        border-radius: 50% !important;
        background: #ffffff !important;
        border: 2px solid rgba(148, 163, 184, 0.25) !important;
        display: flex;
        align-items: center;
        justify-content: center;
        box-shadow: 0 10px 30px rgba(15, 23, 42, 0.12);
        transition: transform 0.2s ease, box-shadow 0.2s ease;
    }

        .btn-close-modern svg {
            color: #334155;
        }

        .btn-close-modern:hover {
            transform: scale(1.07);
            box-shadow: 0 14px 34px rgba(37, 99, 235, 0.2);
            background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%) !important;
            border-color: transparent !important;
        }

            .btn-close-modern:hover svg {
                color: #ffffff;
            }

        .btn-close-modern:disabled {
            opacity: 0.7;
            cursor: not-allowed;
        }

    .btn-md {
        z-index: 1001;
    }

    .btn-modern-primary {
        border: none;
        border-radius: 12px;
        padding: 14px 20px;
        font-weight: 700;
        letter-spacing: 0.3px;
        text-transform: uppercase;
        background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);
        box-shadow: 0 12px 28px rgba(37, 99, 235, 0.35);
        transition: transform 0.2s ease, box-shadow 0.2s ease;
    }

        .btn-modern-primary:hover {
            transform: translateY(-2px);
            box-shadow: 0 16px 32px rgba(37, 99, 235, 0.4);
        }

        .btn-modern-primary:active {
            transform: translateY(0);
        }

    .modern-btn {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        gap: 8px;
        padding: 12px 22px;
        border-radius: 14px;
        font-weight: 600;
        font-size: 14px;
        letter-spacing: 0.3px;
        text-transform: uppercase;
        border: none;
        cursor: pointer;
        transition: transform 0.2s ease, box-shadow 0.2s ease;
        box-shadow: 0 8px 22px rgba(15, 23, 42, 0.12);
        color: #ffffff;
    }

    .modern-btn:hover {
        transform: translateY(-2px);
    }

    .modern-btn:disabled {
        opacity: 0.6;
        cursor: not-allowed;
        transform: none;
    }

    .modern-btn-primary {
        background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);
    }

    .modern-btn-secondary {
        background: linear-gradient(135deg, #94a3b8 0%, #64748b 100%);
    }

    .modern-btn-danger {
        background: linear-gradient(135deg, #f87171 0%, #ef4444 100%);
        color: #ffffff;
    }

    .modern-btn-light {
        background: linear-gradient(135deg, #f1f5f9 0%, #e2e8f0 100%);
        color: #475569;
        box-shadow: 0 4px 12px rgba(15, 23, 42, 0.08);
    }

    .modern-btn-light:hover {
        background: linear-gradient(135deg, #e2e8f0 0%, #cbd5e1 100%);
    }

    .spinner-border-sm {
        width: 1rem;
        height: 1rem;
        border-width: 0.15em;
    }

    @media (max-width: 768px) {
        .modal-modern-header,
        .modal-modern-body,
        .modal-modern-footer {
            padding: 24px 20px;
        }

        .modal-modern-header {
            flex-direction: column;
            align-items: stretch;
            gap: 14px;
        }

            .modal-modern-header::after {
                left: 20px;
                right: 20px;
            }

            .modal-modern-header .header-icon {
                width: 56px;
                height: 56px;
            }

        .header-status {
            width: 100%;
        }

        .tabs-row {
            width: 100%;
        }

        .tab-btn {
            flex: 1;
        }

        .form-group-inline {
            flex-direction: column;
            align-items: stretch;
        }

        .form-grid-2,
        .form-grid-3 {
            grid-template-columns: 1fr;
        }

        .header-toolbar {
            flex-direction: column;
            align-items: stretch;
            gap: 16px;
        }

        .left-tools {
            flex-direction: column;
            align-items: stretch;
        }

        .filter-select {
            min-width: 100%;
        }

        .search-box {
            max-width: none;
        }
    }

    @media (max-width: 576px) {
        .modal-modern-header .header-text h2 {
            font-size: 22px;
        }

        .modal-modern-header .header-text p {
            font-size: 13px;
        }
    }

    [data-bs-theme="dark"] .modern-modal .modal-modern-content {
        background: linear-gradient(135deg, #0f172a 0%, #111826 100%) !important;
        box-shadow: 0 20px 60px rgba(0, 0, 0, 0.55);
    }

    [data-bs-theme="dark"] .modal-modern-header .header-icon {
        background: linear-gradient(135deg, rgba(59, 130, 246, 0.18) 0%, rgba(45, 212, 191, 0.18) 100%);
        color: #60a5fa;
    }

    [data-bs-theme="dark"] .modal-modern-header .header-text h2 {
        color: #f8fafc;
    }

    [data-bs-theme="dark"] .modal-modern-header .header-text p {
        color: #94a3b8;
    }

    [data-bs-theme="dark"] .modal-modern-body {
        background: transparent;
    }

    [data-bs-theme="dark"] .modern-modal .form-control {
        background-color: rgba(15, 23, 42, 0.8);
        border-color: rgba(148, 163, 184, 0.2);
        color: #e2e8f0;
    }

        [data-bs-theme="dark"] .modern-modal .form-control:focus {
            background-color: rgba(15, 23, 42, 0.95);
        }

    [data-bs-theme="dark"] .modern-modal select.form-control,
    [data-bs-theme="dark"] .modern-modal select.form-control:focus {
        background-color: rgba(15, 23, 42, 0.8);
        background-image: url("data:image/svg+xml,%3Csvg width='14' height='9' viewBox='0 0 14 9' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 1.5L7 7.5L13 1.5' stroke='%2394A3B8' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
        background-repeat: no-repeat;
        background-position: right 16px center;
        background-size: 14px 9px;
    }

        [data-bs-theme="dark"] .modern-modal select.form-control:focus {
            background-color: rgba(15, 23, 42, 0.95);
        }

    [data-bs-theme="dark"] .modern-modal select.form-control option {
        background: #1f2937;
        color: #e2e8f0;
    }

    [data-bs-theme="dark"] .modern-modal .form-label {
        color: #e2e8f0;
    }

    [data-bs-theme="dark"] .modal-modern-header::after {
        background: linear-gradient(90deg, transparent, rgba(148, 163, 184, 0.25), transparent);
    }

    [data-bs-theme="dark"] .modal-modern-footer {
        background: transparent;
    }

    [data-bs-theme="dark"] .form-group-inline .info-chip {
        background: rgba(37, 99, 235, 0.15);
        color: #cbd5f5;
    }

    [data-bs-theme="dark"] .modern-modal small.text-muted {
        color: #94a3b8;
    }

    [data-bs-theme="dark"] .btn-close-modern {
        background: rgba(15, 23, 42, 0.9) !important;
        border-color: rgba(148, 163, 184, 0.25) !important;
    }

        [data-bs-theme="dark"] .btn-close-modern svg {
            color: #e2e8f0;
        }

        [data-bs-theme="dark"] .btn-close-modern:hover {
            background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%) !important;
        }

    [data-bs-theme="dark"] .btn-modern-primary {
        background: linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%);
        box-shadow: 0 12px 28px rgba(37, 99, 235, 0.45);
    }

    [data-bs-theme="dark"] .modern-modal .form-control::placeholder {
        color: #64748b;
    }

    [data-bs-theme="dark"] .header-toolbar {
        background: linear-gradient(135deg, rgba(30, 41, 59, 0.6) 0%, rgba(15, 23, 42, 0.8) 100%);
        border-color: rgba(71, 85, 105, 0.4);
        box-shadow: 0 4px 16px rgba(0, 0, 0, 0.2);
    }

    [data-bs-theme="dark"] .filter-label {
        color: #94a3b8;
    }

    [data-bs-theme="dark"] .filter-select-input:focus {
        background-color: rgba(15, 23, 42, 0.95);
        background-image: url("data:image/svg+xml,%3Csvg width='12' height='8' viewBox='0 0 12 8' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 1.5L6 6.5L11 1.5' stroke='%2394a3b8' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
        background-repeat: no-repeat;
        background-position: right 14px center;
        background-size: 12px 8px;
    }

    [data-bs-theme="dark"] .filter-select-input {
        background-color: rgba(15, 23, 42, 0.8);
        background-image: url("data:image/svg+xml,%3Csvg width='12' height='8' viewBox='0 0 12 8' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 1.5L6 6.5L11 1.5' stroke='%2394a3b8' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
        border-color: rgba(71, 85, 105, 0.5);
        color: #e2e8f0;
        background-repeat: no-repeat;
        background-position: right 14px center;
        background-size: 12px 8px;
    }

    [data-bs-theme="dark"] .search-box .search-icon {
        color: #64748b;
    }

    [data-bs-theme="dark"] .search-box:focus-within .search-icon {
        color: #60a5fa;
    }

    [data-bs-theme="dark"] .search-input {
        background: rgba(15, 23, 42, 0.8);
        border-color: rgba(71, 85, 105, 0.5);
        color: #e2e8f0;
    }

    [data-bs-theme="dark"] .search-input::placeholder {
        color: #64748b;
    }

    [data-bs-theme="dark"] .search-input:focus {
        background: rgba(15, 23, 42, 0.95);
    }

    [data-bs-theme="dark"] .tab-btn.blocked {
        opacity: 0.4;
    }

    [data-bs-theme="dark"] .total-chip {
        background: linear-gradient(135deg, #1e3a5f 0%, #1e40af 100%);
        border-color: #3b82f6;
        color: #93c5fd;
    }

    [data-bs-theme="dark"] .total-chip:hover {
        background: linear-gradient(135deg, #1e40af 0%, #1e3a8a 100%);
    }

    [data-bs-theme="dark"] .total-chip.chip-active {
        background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);
        border-color: #60a5fa;
        color: #ffffff;
    }

    [data-bs-theme="dark"] .section-card {
        background: linear-gradient(135deg, rgba(15, 23, 42, 0.9) 0%, rgba(30, 41, 59, 0.94) 100%);
        border-color: rgba(71, 85, 105, 0.55);
    }

    [data-bs-theme="dark"] .modern-btn-light {
        background: linear-gradient(135deg, #1e293b 0%, #334155 100%);
        color: #e2e8f0;
    }

    [data-bs-theme="dark"] .modern-btn-light:hover {
        background: linear-gradient(135deg, #334155 0%, #475569 100%);
    }

    [data-bs-theme="dark"] .tabs-row {
        background: rgba(15, 23, 42, 0.85);
        border-color: rgba(71, 85, 105, 0.55);
    }

    [data-bs-theme="dark"] .tab-btn {
        color: #94a3b8;
    }

        [data-bs-theme="dark"] .tab-btn:hover {
            background: rgba(59, 130, 246, 0.15);
            color: #93c5fd;
        }

        [data-bs-theme="dark"] .tab-btn.blocked:hover {
            background: transparent;
            color: #94a3b8;
        }

    [data-bs-theme="dark"] .modern-table .custom-table {
        border-color: rgba(71, 85, 105, 0.45);
    }

        [data-bs-theme="dark"] .modern-table .custom-table thead,
        [data-bs-theme="dark"] .modern-table .custom-table.custom-table-detalhes tbody tr,
        [data-bs-theme="dark"] .modern-table .custom-table.custom-table-detalhes thead tr {
            background: linear-gradient(135deg, #111827 0%, #1f2937 100%);
        }

        [data-bs-theme="dark"] .modern-table .custom-table th,
        [data-bs-theme="dark"] .modern-table .custom-table td {
            color: #e2e8f0;
            border-bottom-color: rgba(71, 85, 105, 0.35);
        }

        [data-bs-theme="dark"] .modern-table .custom-table tbody tr:hover {
            background: rgba(59, 130, 246, 0.12);
        }

        [data-bs-theme="dark"] .modern-table .custom-table.custom-table-quantidades tbody tr {
            background: rgba(59, 130, 246, 0.1);
        }

    [data-bs-theme="dark"] .item-name {
        color: #f3f4f6;
    }

    [data-bs-theme="dark"] .item-details {
        color: #9ca3af;
    }

    [data-bs-theme="dark"] .id-badge,
    [data-bs-theme="dark"] .number-badge {
        background: rgba(37, 99, 235, 0.22);
        border-color: rgba(59, 130, 246, 0.35);
        color: #93c5fd;
    }

    [data-bs-theme="dark"] .pill-ok {
        background: rgba(16, 185, 129, 0.22);
        color: #34d399;
        border-color: rgba(16, 185, 129, 0.35);
    }

    [data-bs-theme="dark"] .pill-off {
        background: rgba(239, 68, 68, 0.22);
        color: #f87171;
        border-color: rgba(239, 68, 68, 0.35);
    }

    [data-bs-theme="dark"] .section-card .card-title,
    [data-bs-theme="dark"] .details-card .card-title {
        color: #cbd5e1;
    }
</style>
